// PaktWordmark.tsx — "pakt." — geometric grotesk with colored full-stop.

import React from 'react';

export interface PaktWordmarkProps {
  size?: number;
  color?: string;
  dotColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function PaktWordmark({
  size = 34,
  color = '#0A0A0A',
  dotColor = '#FF5B2E',
  className,
  style,
}: PaktWordmarkProps) {
  return (
    <div
      className={className}
      style={{
        fontFamily: '"Helvetica Neue", Arial, sans-serif',
        fontWeight: 900,
        fontSize: size,
        letterSpacing: '-0.04em',
        color,
        lineHeight: 1,
        ...style,
      }}
    >
      pakt<span style={{ color: dotColor }}>.</span>
    </div>
  );
}
